export const environment = {
  production: false,

  SERVER: "wasellipsesmthdevellipse.azurewebsites.net",
  BASEURL: "https://wasellipsesmthdevellipse.azurewebsites.net/smthapi/v1",

  // SERVER: 'smthportaltest.azurewebsites.net',
  // BASEURL: 'https://smthportaltest.azurewebsites.net/SmthApi',
  //BASEURL: 'https://wasellipsesmthdevellipse.azurewebsites.net/SmthApi',

  // SERVER: 'smthapp.azurewebsites.net',
  // BASEURL : 'https://smthapp.azurewebsites.net/SmthApi',

  INSTRUMENTATION_KEY: "72d95a72-b6fd-432f-a891-65ce516972c1",

  ENCRYPTKEY: 'dSgVkYp2s5v8y/B?',
  ENCRYPTKEY_DATA: "art&54490p$xcp!+456_tyff",
  CLIENT_ID: "",
  AUTHORITY: "",
  API:"",
  REDIRECT_URI: "",
  FILE_SIZE: 0,
  //  DASHBOARD: '/dashboard/{id}', /dashboardfilterTestSlips?depot=3,4&
  DASHBOARD: "/dashboard/{id}",
  GET_USER_BY_ADID: "/email/{email}",
  GET_USER_EXIST: "/users/{userName}",
  // GET_ADUSER_BY_TEXT: '/AzureAD/UserByText?text={text}',
  GET_ADUSER_BY_TEXT: "/GetUsers/{keyWord}/1",
  GET_ADUSER_EXTERNAL_TEXT: "/GetUsers/{keyWord}/2",
  GET_SYSUSER_EXTERNAL_TEXT: "/GetUsers/{keyWord}/3",
  GET_SYSUSER_BY_TEXT: "/GetUsers/{keyWord}/4",
  GET_SYSUSER_BY_TEXT_USERID: "/GetUsers/{keyWord}/5",
  INSERT_OR_UPDATE_USERS: "/UserAccess/UsersProfile",
  GET_ORG_HIERARCHY: "/OrganisationsByUserId/{id}",
  GET_ROLES: "/GetRoles",
  GET_ADMIN_ORG_STRUCTURE: "/GetOrgDataNames",
  GET_PERMISSIONS: "/UserManagement/Permissions",
  GETUSERDETAILS: "/users/{userName}",
  GETUSERDETAILSBYOID: "/users/oid/{oid}",
  SETTESTSLIPSTATUS: "/setTestSlipStatus",
  ADD_COMMENTS: "/comments",
  GET_COMMENTS: "/getComments",
  VIEWTESTSLIP: "/testslips",
  VIEWUSERNAME: "/usersById",
  VIEWTESTPLAN: "/testPlan",
  GETTESTPLANITEMS: "/testplandetails/{testPlanId}/testPlanItems",
  FILTERTESTSLIPS: "/filterTestSlips",
  FILTERTESTSLIPSEXPORT: "/filterTestSlipsExport{data}",
  COLUMNFILTER: "/dashboardFilterTestSlips",
  DELETE_COMMENTS: "/DeleteComments",
  GET_EXISTING_USER: "/users",
  ACTIVEDEACTIVE_USER_BY_ID: "/setUserStatus/{userId}/{isActive}/{modifiedBy}",
  UPDATE_HANDOVER:"/UpdateTestSlip/{testSlipId}/{handOverFrom}/{handedOverTo}",
  GET_USERAUDIT: "/UserAuditTrail/{userId}",
  UPLOAD_SMS_DOCS: "/uploadSMSLinkDocuments",
  GET_SMS_DOCS: "/GetSMSLinkDocuments",
  GET_APPVERSIONLIST:"/masterTestPlanVersion",
  Level_Approval: "/LevelApproval",
  TEST_PLANS: "/testPlans/{userId}"
};
